import React, { useState } from 'react';
import AccordionItem from '../AccordionItem/AccordionItem';
import { accordianData } from './data';

import './Accordion.scss';

const Accordion = () => {
  const [showContent, setShowContent] = useState(0);

  const toggle = (idx) => {
    if (idx === showContent) {
      setShowContent(-1);
    } else {
      setShowContent(idx);
    }
  };

  return (
    <div className="accordion">
      {accordianData.map((item, idx) => (
        <AccordionItem
          title={item.title}
          key={item.title}
          content={item.content}
          icon={item.icon}
          image={item.image}
          showContent={showContent === idx}
          toggle={() => toggle(idx)}
        />
      ))}
    </div>
  );
};

export default Accordion;
